// 隐私政策相关接口
import fetch from '../utils/fetch'

export function getPrivacyConfig(query) {
  return fetch({
    url: '/wxa/privacy/setting',
    method: 'get',
    params: query
  })
}


export function uploadPrivacyFile(params) {
  return fetch({
    url: '/wxa/uploadprivacy/extfile',
    method: 'post',
    params
  })
}


export function savePrivacyConfig(params) {
  return fetch({
    url: '/wxa/privacy/setting',
    method: 'post',
    params
  })
}
